import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType,ref ,computed } from 'vue';
  import { NButton } from 'naive-ui'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    label: {
        type:String,
        default:''
    },
    type: {
        type:String,
        default:'primary', // 'tertiary' | 'primary' | 'info' | 'success' | 'warning' | 'error'
    },
    size: {
        //'tiny' | 'small' | 'medium' | 'large'
        type:String,
        default:'medium'
    },
    loading: {
        type:Boolean,
        default:false
    },
    disabled: {
        type:Boolean,
        default:false
    },
    iconPlacement: {
        type:String,
        default:'left',//图标位置 'left' | 'right'
    },
    tag: {
        type:String,
        default:'',//按钮标签
    },
    block: {
        type:Boolean,
        default:false,//是否块级元素
    },
    isHiddenMouse:{
        type:Boolean,
        default:false
    },
    isSetMouseHidden:{
        type:Boolean,
        default:false
    }
  },
  setup(__props) {

  const props = __props;

  const mouseStyle = computed(()=>{
    if(props.isSetMouseHidden){
        return `cursor: ${props.isHiddenMouse?'none !important':'pointer !important'}`
    }else{
        return ''
    }
  })



  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.disabled?'disabled-btn button-container':'none-disabled button-container')
  }, [
    _createVNode(_unref(NButton), {
      strong: "",
      secondary: "",
      type: __props.type,
      size: __props.size,
      loading: __props.loading,
      disabled: __props.disabled,
      "icon-placement": __props.iconPlacement,
      style: _normalizeStyle(mouseStyle.value)
    }, {
      icon: _withCtx(() => [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label) + " ", 1)
      ]),
      _: 3
    }, 8, ["type", "size", "loading", "disabled", "icon-placement", "style"])
  ], 2))
}
}

})